import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { FormSearchComponent } from '../../../../shared/components/form-search/form-search.component'
import { PaginationComponent } from '../../../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../../../shared/components/table-list/table-list.component'
import { LegalEntityClientService } from '../../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import { AuthService } from '../../../../core/services/auth/auth.service'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../../../core/models/contact-type.model'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { TableListSelectComponent } from '../../../../shared/components/table-list-select/table-list-select.component'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { ClientCreateComponent } from '../../client-create/client-create.component'
import { LegalEntityClientComponent } from '../../../../pages/customer/legal-entity-client/legal-entity-client.component'
import { MatTab } from '@angular/material/tabs'
import { FormClientSearchComponent } from '../../../../shared/components/form-client-search/form-search.component'
import { responseDefaultForm } from '../../../../shared/utils/utils'

@Component({
  selector: 'modal-legal-entity-client',
  imports: [
    FormSearchComponent,
    MatProgressBar,
    PaginationComponent,
    TableListComponent,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatIcon,
    TableListSelectComponent,
    MatButton,
    MatProgressSpinner,
    LegalEntityClientComponent,
    MatTab,
    FormClientSearchComponent,
  ],
  templateUrl: './modal-legal-entity-client.component.html',
  styleUrl: './modal-legal-entity-client.component.scss',
  standalone: true,
  providers: [LegalEntityClientService],
})
export class ModalLegalEntityClientComponent implements OnInit {
  constructor(
    private legalEntityClientService: LegalEntityClientService,
    private dialogRef: MatDialogRef<ModalLegalEntityClientComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.multiSelect = data.multiSelect ?? false
    if (this.multiSelect) {
      this.listSelected = data.item
    } else {
      this.selected = data.item
    }
    if (data.create) {
      this.createBtn = true
    }
  }

  multiSelect: boolean = false

  @Output() responseSingle = new EventEmitter()
  @Output() responseMulti = new EventEmitter()

  listSelected: any[] = []
  selected: any = { id: -1, description: '' }

  createBtn: boolean = false

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false

  listSearch: any = [
    { id: 'nomeFantasia', description: 'Nome', type: 'string', visible: true },
    // { id: 'cpf', description: 'CPF', type: 'string', visible: true },
    {
      id: 'razaoSocial',
      description: 'Razão Social',
      type: 'string',
      visible: true,
    },
    { id: 'cnpj', description: 'CNPJ/CPF', type: 'string', visible: true },
    {
      id: 'inscricaoMunicipal',
      description: 'Inscrição Municipal',
      type: 'string',
      visible: false,
    },
    {
      id: 'inscricaoEstadual',
      description: 'Inscrição Estadual',
      type: 'string',
      visible: false,
    },
  ]

  inputSearch: any = { type: '', search: '' }
  searchForm: any = { search: false, model: {} }

  columns: any[] = [
    {
      keyColumn: 'action',
      key: { select: true },
      description: '',
    },
    {
      keyColumn: 'name',
      key: 'nomeFantasia',
      description: 'Nome Fantasía',
    },
    {
      keyColumn: 'corporate_name',
      key: 'razaoSocial',
      description: 'Razão social',
    },
    {
      keyColumn: 'cnpj',
      key: 'cnpj',
      description: 'CNPJ/CPF',
    },
  ]
  screen: string = 'status operação'

  ngOnInit() {
    this.getListItems()
  }

  close() {
    this.dialogRef.close()
  }

  // search(event: any) {
  //   let search = event
  //   this.page = 1
  //   if (search) {
  //     this.searchForm.descricao = search
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }
  search(event: any) {
    if (event.search) {
      this.searchForm = {
        search: true,
        model: this.createModel(event.data),
      }
    }
    this.page = 1
    this.uploadList(!event.search ? 'new' : '')
  }

  createModel(element: any) {
    let model: any = {}
    for (let i = 0; i < this.listSearch.length; i++) {
      const item = this.listSearch[i]
      model[item.id] =
        item.id == element.type
          ? element.search
          : responseDefaultForm(item.type)
    }
    return model
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  // uploadList(type: string = '') {
  //   if (type == 'new') {
  //     this.searchForm = new SearchContactTypeModel()
  //   }
  //   if (this.searchForm.descricao) {
  //     this.searchListItems()
  //   } else {
  //     this.getListItems()
  //   }
  // }
  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = { search: false, model: {} }
    }
    if (this.searchForm.search) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  getListItems() {
    this.loading = true
    this.legalEntityClientService
      .listPagedLegalEntityClient(this.page, this.rows)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  searchListItems() {
    this.loading = true
    this.legalEntityClientService
      .searchPagedLegalEntityClient(this.page, this.rows, this.searchForm.model)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }

  selectItem(event: any) {
    if (this.multiSelect) {
      let index = this.listSelected.findIndex((ele) => ele.id == event.id)
      if (index > -1) {
        this.listSelected.splice(index, 1)
      } else {
        this.listSelected.push(event)
      }
    } else {
      if (this.selected.id == event.id) {
        this.selected = { id: -1, description: '' }
      } else {
        this.selected = event
      }
    }
  }

  checkForm() {
    if (this.selected.id >= 0 || this.listSelected.length > 0) {
      return true
    } else {
      return false
    }
  }

  removeSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: true })
    } else {
      this.responseSingle.emit({ remove: true })
    }
    this.close()
  }

  confirmSelection() {
    if (this.multiSelect) {
      this.responseMulti.emit({ remove: false, selection: this.listSelected })
    } else {
      this.responseSingle.emit({ remove: false, selection: this.selected })
    }
    this.close()
  }

  editItem(event: any) {
    console.log('event', event)
  }

  deleteItem(event: any) {
    console.log('event', event)
  }

  newClient() {
    const dialogRef = this.dialog.open(ClientCreateComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { modal: true },
    })
    dialogRef.componentInstance.responseModal.subscribe((response) => {
      console.log('response: ', response)
      this.uploadList()
    })
  }
}
